import { Button } from "./styled";

export const ButtonRegiter = ({ width, height = '56px', ...other }) => {
  
  return <Button width={width} height={height} {...other} >Đăng ký</Button>;
};
